import { httpGet } from "@/request/http";
import func from "@/funcs";

let path = "/upload-logs";

export default {
  get(id) {
    return httpGet(`${path}/${id}/details`);
  },
  getPages(dTO) {
    return httpGet(`${path}/pages`, dTO);
  },
  getExcel() {
    func.getExcel.get(`${path}/excel`, "第三方上傳記錄");
  },
};
